import { Model } from '@/models/Model';
export class LabelGroup extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'LabelGroup';
        this.$endpoint = '/label-groups';
        this.$fillable = ['name'];
    }
}
export var LabelGroupIncludes;
(function (LabelGroupIncludes) {
    LabelGroupIncludes["LABELS"] = "labels";
    LabelGroupIncludes["SUBJECTS"] = "subjects";
})(LabelGroupIncludes || (LabelGroupIncludes = {}));
